"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { SvgIconType } from '../SvgIcon/svg-icon-type.mjs';
import { forwardRef } from 'react';
import { dropdownRecipe } from '../../recipes/dropdown.mjs';
import { ItemIcon } from './ItemIcon.mjs';

const ErrorHeading = forwardRef(({ className, text, ...props }, ref) => {
  const styles = dropdownRecipe();
  return /* @__PURE__ */ jsxs("span", { role: "heading", "aria-level": 2, className: clsx(styles["error-heading"], className), ...props, ref, children: [
    /* @__PURE__ */ jsx(ItemIcon, { type: SvgIconType.AlertCircle, className: styles["error-heading-icon"] }),
    text
  ] });
});

export { ErrorHeading };
